import { getYearsOfExistence } from '~~/helpers/getYearsOfExistence';

const PLACEHOLDER_PATTERN = /\{(\w+)\}/g;

/**
 * CMS promo banner copy can refer to values the CMS file cannot hold, through
 * `{placeholders}`. A placeholder is known when it has an entry here, and its
 * value is `null` until the data behind it is available - a text mentioning
 * such a placeholder is not displayable yet.
 */
export const usePromoBannerPlaceholders = () => {

  const { distinctProductsDiscount } = useDistinctProductsDiscount();

  const placeholderValues = computed<Record<string, string | null>>(() => ({
    yearsOfExistence: String(getYearsOfExistence()),
    discountPercentage: distinctProductsDiscount.value
      ? String(distinctProductsDiscount.value.discountPercentage)
      : null,
    minimalQuantity: distinctProductsDiscount.value
      ? String(distinctProductsDiscount.value.minimalQuantity)
      : null,
  }));

  const isResolvable = (text: string) => {

    return [...text.matchAll(PLACEHOLDER_PATTERN)]
      .every(([, name = '']) => placeholderValues.value[name] !== null);

  };

  const resolvePlaceholders = (text: string) => {

    return text.replace(
      PLACEHOLDER_PATTERN,
      (placeholder, name) => placeholderValues.value[name] ?? placeholder,
    );

  };

  return {
    isResolvable,
    resolvePlaceholders,
  };

};
